import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the Tokyo production region (`enterprise.jp.wisesystems.io`)
 */
export const tokyoServerConfig: ServerBaseUrl = {
    apiServer: 'https://api.jp.wisesys.info',
    auroraApiServer: 'https://aurora-v2.wisesys.info',
    socketServer: 'wss://jp.socket.wisesys.info',
    auroraServer: '',
    environment: ServerEnvironment.TOKYO,
    CIEnv: ServerCIEnvironment.PRODUCTION,
    vehicleProfile:
        'https://1nzw6ikhc4.execute-api.ap-northeast-1.amazonaws.com/Tokyo',
    routePathGeometryServer:
        'https://0q6k5or5lc.execute-api.ap-northeast-1.amazonaws.com/production',
    configurableWorkflowServer:
        'https://zcqwzh2eue.execute-api.us-east-1.amazonaws.com/Prod',
    initialVsActualServer:
        'https://918codx572.execute-api.ap-northeast-1.amazonaws.com/production',
    // TODO(CD-112): regional prod — Cognito differs from dcs-prod; needs own regional dcs stack
    driverCostServer: ''
};
